import * as React from 'react';
import { StyledGridCell } from './StyledGridCell';

export const GridOneQuarter = ({children, className = ""}) => <StyledGridCell lg={3} xs={12} item={true} className={className}>{children}</StyledGridCell>;
